function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import useData from "./data";
import { LoadingSpinner } from "../../../../Common/LoadingUI";
// config will be provided via props
import Button from "../../../../Common/Button";
import DealSection from "../../DealSection";
import useBookingSummary from "../../../../../Hooks/use-bookingSummary";
import { loadMoreSvg } from "../../ProductListing/svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Confirmation = function Confirmation(_ref) {
  var _config$deals;
  var _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    appType = _ref.appType,
    isPoints = _ref.isPoints;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isSuccess = _useState2[0],
    setIsSuccess = _useState2[1];
  var params = (router === null || router === void 0 ? void 0 : router.params) || {};
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {}
  };
  // const[loading , setLoading]=useState(true)
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = (redux === null || redux === void 0 ? void 0 : redux.authActions) || {};
  var _useData = useData(params.orderId, {
      redux: redux,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingOrder = _useData.loadingOrder,
    payment = _useData.payment,
    showError = _useData.showError,
    isAuthenticated = _useData.isAuthenticated,
    deals = _useData.deals;
  var _useBookingSummary = useBookingSummary({
      redux: {
        isAuthenticated: redux === null || redux === void 0 ? void 0 : redux.isAuthenticated,
        dispatch: dispatch,
        authActions: authActions
      },
      winnreAuth: winnreAuth,
      appType: appType,
      isPoints: isPoints
    }),
    userAccountSummary = _useBookingSummary.userAccountSummary;
  var openLoginModal = function openLoginModal() {
    if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
      dispatch(authActions.openLoginModal());
    }
  };
  // const ordersRoute =
  //   appType === "connectre"
  //     ? isPoints
  //       ? "/myprofile/coinStore/orders"
  //       : "/myprofile/rewardStore/orders"
  //     : "/myProfile/coinStore/Orders";
  var ordersRoute = appType === "winnre" ? "/myProfile/coinStore/Orders" : isPoints ? "/myProfile/coinStore/Orders" : "/myProfile/rewardStore/Orders";
  useEffect(function () {
    if ((payment === null || payment === void 0 ? void 0 : payment.paymentStatus) === "FAILED") {
      setIsSuccess(false);
    } else {
      setIsSuccess(true);
    }
  }, [payment]);
  var redeemNowButtonConfig = (config === null || config === void 0 || (_config$deals = config.deals) === null || _config$deals === void 0 || (_config$deals = _config$deals.dealLayout) === null || _config$deals === void 0 ? void 0 : _config$deals.redeemNowButtonConfig) || {};
  if (!isAuthenticated) {
    return /*#__PURE__*/_jsx("div", {
      className: "py-12 flex justify-center items-center h-[80vh]",
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, redeemNowButtonConfig), {}, {
        content: "Login to check Order Status",
        onClick: "FUNC",
        onClickFunc: openLoginModal,
        config: config,
        redux: redux,
        router: router
      }))
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [loadingOrder && /*#__PURE__*/_jsx("div", {
      className: "h-[40vh] flex justify-center items-center py-6",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    }), !loadingOrder && showError && isAuthenticated && /*#__PURE__*/_jsx("div", {
      className: "w-[95%] lg:w-full flex flex-col items-center justify-center min-h-[80vh] mx-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-center mb-4",
          children: /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: " w-[50px] h-[50px] md:w-[70px] md:h-[70px]",
            viewBox: "0 0 100 100",
            children: /*#__PURE__*/_jsx("path", {
              id: "failed",
              d: "M50.5.5a50,50,0,1,0,50,50,50,50,0,0,0-50-50ZM66.967,62.3a3.222,3.222,0,0,1,0,4.667,3.127,3.127,0,0,1-2.333,1,3.235,3.235,0,0,1-2.333-1l-11.8-11.8-11.8,11.8a3.235,3.235,0,0,1-2.333,1,3.127,3.127,0,0,1-2.333-1,3.222,3.222,0,0,1,0-4.667l11.8-11.8-11.8-11.8A3.3,3.3,0,1,1,38.7,34.033l11.8,11.8,11.8-11.8A3.3,3.3,0,1,1,66.967,38.7l-11.8,11.8Z",
              transform: "translate(-0.5 -0.5)",
              fill: "#f44336"
            })
          })
        }), /*#__PURE__*/_jsx("h1", {
          className: " text-xl md:text-2xl font-bold mb-2",
          children: "Order Not Found or Deal Expired"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-black text-base mb-4",
          children: "Sorry, we were unable to find the order or the deal has expired."
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-black",
          children: ["Also, you can track your orders on", " ", /*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              var _history$push;
              return history === null || history === void 0 || (_history$push = history.push) === null || _history$push === void 0 ? void 0 : _history$push.call(history, ordersRoute);
            },
            className: "text-blue-700 cursor-pointer",
            children: "My Orders"
          }), " ", "page"]
        }), /*#__PURE__*/_jsx("button", {
          className: " mt-4 px-4 py-2 bg-blue-800 text-white rounded",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center gap-1",
            children: [/*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14.216",
              height: "14.216",
              viewBox: "0 0 14.216 14.216",
              children: /*#__PURE__*/_jsxs("g", {
                id: "reload",
                transform: "translate(-2 -2)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_7395",
                  "data-name": "Path 7395",
                  d: "M15.569,3.422a.711.711,0,0,0-.711.711v.713A7.108,7.108,0,0,0,2.24,7.529a.711.711,0,0,0,1.387.315,5.68,5.68,0,0,1,10.46-1.579H12.726a.711.711,0,1,0,0,1.422h2.843a.711.711,0,0,0,.711-.711V4.132A.711.711,0,0,0,15.569,3.422Z",
                  transform: "translate(-0.064)",
                  fill: "#fff"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_7396",
                  "data-name": "Path 7396",
                  d: "M2.711,17.975a.711.711,0,0,0,.711-.711v-.729A7.1,7.1,0,0,0,16.04,13.868a.711.711,0,0,0-1.387-.315A5.677,5.677,0,0,1,4.2,15.132H5.554a.711.711,0,1,0,0-1.422H2.711A.711.711,0,0,0,2,14.421v2.843a.711.711,0,0,0,.711.711Z",
                  transform: "translate(0 -3.181)",
                  fill: "#fff"
                })]
              })
            }), /*#__PURE__*/_jsx("p", {
              children: "Try Again"
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "mt-8 bg-[#EDEEF0] rounded-xl  p-6 flex flex-col md:flex-row md:items-center gap-4 md:justify-between  mr-3 md:mr-0",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "text-left mb-6 lg:mb-0",
            children: [/*#__PURE__*/_jsx("h3", {
              className: "text-base font-bold whitespace-nowrap ",
              children: "Need Assistance ?"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-gray-700 whitespace-nowrap",
              children: "Try contacting us"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: " w-full flex items-center justify-center md:justify-end gap-2 text-left cursor-pointer md:-mt-4 lg:-mt-0 xl:-mt-0 ",
            onClick: function onClick() {
              var _history$push2;
              history === null || history === void 0 || (_history$push2 = history.push) === null || _history$push2 === void 0 || _history$push2.call(history, "/contact-us");
            },
            children: [/*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg"
              // className="w-[30px] h-[30px]"
              ,
              width: "37.323",
              height: "30.833",
              viewBox: "0 0 37.323 30.833",
              children: /*#__PURE__*/_jsx("path", {
                id: "customer-service",
                d: "M45.307,67.956a5.376,5.376,0,0,1-5.134,5.6q-.125.006-.249.006a5.272,5.272,0,0,1-1.124-.122,14.479,14.479,0,0,1-9.787,6.413,3.13,3.13,0,1,1-.1-2.273,12.194,12.194,0,1,0-12.9-6.045.74.74,0,0,1,.075.19,1.126,1.126,0,0,1-.626,1.42,5.316,5.316,0,0,1-2.063.416q-.125,0-.251-.006a5.375,5.375,0,0,1-5.131-5.6c.024-.567.011-1.073,0-1.562-.012-.461-.025-.937,0-1.434a5.38,5.38,0,0,1,5.4-5.139,14.449,14.449,0,0,1,26.5,0,5.376,5.376,0,0,1,5.4,5.138c.021.5.008.974,0,1.435C45.3,66.883,45.283,67.389,45.307,67.956ZM36.129,65.59a9.47,9.47,0,0,1-11.9,9.15L20.4,76.953a1.129,1.129,0,0,1-1.655-1.27l.979-3.653a9.467,9.467,0,1,1,16.406-6.44Zm-12.1,0A1.129,1.129,0,0,0,22.9,64.461h0a1.129,1.129,0,1,0,1.131,1.129Zm3.761,0a1.068,1.068,0,0,0-.006-.111,1.053,1.053,0,0,0-.016-.11.854.854,0,0,0-.027-.107c-.01-.035-.023-.07-.037-.1a.926.926,0,0,0-.047-.1,1.087,1.087,0,0,0-.056-.095,1.1,1.1,0,0,0-.066-.09.952.952,0,0,0-.074-.082c-.026-.026-.053-.051-.082-.075s-.059-.045-.09-.065a1.083,1.083,0,0,0-.095-.056c-.032-.017-.066-.033-.1-.047a1,1,0,0,0-.1-.037.989.989,0,0,0-.217-.044,1.157,1.157,0,0,0-.331.016,1.07,1.07,0,0,0-.108.028.991.991,0,0,0-.1.037c-.034.014-.068.03-.1.047s-.064.036-.095.056a1.1,1.1,0,0,0-.089.065c-.029.024-.056.049-.083.075a.963.963,0,0,0-.075.082,1.09,1.09,0,0,0-.065.09,1.074,1.074,0,0,0-.057.095,1.01,1.01,0,0,0-.047.1,1.106,1.106,0,0,0-.038.1c-.01.035-.019.071-.027.107a1.075,1.075,0,0,0-.017.11c0,.037-.005.074-.005.111s0,.074.005.111a1.092,1.092,0,0,0,.017.109c.008.036.017.072.027.108a1.093,1.093,0,0,0,.038.1,1.023,1.023,0,0,0,.047.1c.017.032.037.064.057.095a1.079,1.079,0,0,0,.065.089,1.107,1.107,0,0,0,.075.083c.026.026.053.051.083.075a.965.965,0,0,0,.089.065c.031.02.062.04.095.057a1.247,1.247,0,0,0,.2.084c.035.011.071.02.108.027a1.076,1.076,0,0,0,.22.022,1.135,1.135,0,0,0,.8-.33,1.221,1.221,0,0,0,.141-.172q.03-.046.056-.095c.017-.032.033-.066.047-.1a1.047,1.047,0,0,0,.037-.1.9.9,0,0,0,.027-.108,1.069,1.069,0,0,0,.016-.109,1.082,1.082,0,0,0,.006-.112Zm3.762,0a1.129,1.129,0,0,0-1.129-1.129h0a1.129,1.129,0,1,0,1.131,1.129Z",
                transform: "translate(-8.001 -51.138)",
                fill: "#4652a4"
              })
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h4", {
                className: "text-base font-semibold",
                children: "Contact Us"
              }), /*#__PURE__*/_jsx("p", {
                className: "text-gray-600",
                children: "Tell us more about your query"
              })]
            }), /*#__PURE__*/_jsx("svg", {
              className: "ml-2",
              xmlns: "\r\nhttp://www.w3.org/2000/svg",
              width: "9.709",
              height: "17.068",
              viewBox: "0 0 9.709 17.068",
              children: /*#__PURE__*/_jsx("g", {
                id: "next",
                transform: "translate(0.568 0.568)",
                children: /*#__PURE__*/_jsx("g", {
                  id: "Group_11658",
                  "data-name": "Group 11658",
                  children: /*#__PURE__*/_jsx("path", {
                    id: "Path_7346",
                    "data-name": "Path 7346",
                    d: "M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z",
                    transform: "translate(-117.742 0)",
                    fill: "#16519e",
                    stroke: "#16519e",
                    "stroke-width": "1"
                  })
                })
              })
            })]
          })]
        })]
      })
    }), !loadingOrder && payment.id > 0 && /*#__PURE__*/_jsx("div", {
      className: "w-[95%] lg:w-full flex flex-col items-center justify-center min-h-[80vh] mx-4",
      children: isSuccess ? /*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-center mb-2",
          children: /*#__PURE__*/_jsx("img", {
            className: "w-[120px] h-[120px]",
            src: "https://reloy-internal.s3.ap-south-1.amazonaws.com/Gif/delivery.gif"
          })
        }), /*#__PURE__*/_jsx("h1", {
          className: "text-xl font-bold mb-2",
          children: "Thank you!"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-black text-base mb-2 ",
          children: "Wait for the delivery and get ready for the joy!"
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-black text-base",
          children: ["Also we can track your reward points in", " ", /*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              var _history$push3;
              return history === null || history === void 0 || (_history$push3 = history.push) === null || _history$push3 === void 0 ? void 0 : _history$push3.call(history, ordersRoute);
            },
            className: "text-blue-700 text-base cursor-pointer",
            children: "My Orders"
          }), " ", "page."]
        })]
      }) : /*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "flex justify-center items-center mb-4",
          children: /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            className: " w-[50px] h-[50px] md:w-[70px] md:h-[70px]",
            viewBox: "0 0 100 100",
            children: /*#__PURE__*/_jsx("path", {
              id: "failed",
              d: "M50.5.5a50,50,0,1,0,50,50,50,50,0,0,0-50-50ZM66.967,62.3a3.222,3.222,0,0,1,0,4.667,3.127,3.127,0,0,1-2.333,1,3.235,3.235,0,0,1-2.333-1l-11.8-11.8-11.8,11.8a3.235,3.235,0,0,1-2.333,1,3.127,3.127,0,0,1-2.333-1,3.222,3.222,0,0,1,0-4.667l11.8-11.8-11.8-11.8A3.3,3.3,0,1,1,38.7,34.033l11.8,11.8,11.8-11.8A3.3,3.3,0,1,1,66.967,38.7l-11.8,11.8Z",
              transform: "translate(-0.5 -0.5)",
              fill: "#f44336"
            })
          })
        }), /*#__PURE__*/_jsx("h1", {
          className: "text-2xl font-bold mb-2",
          children: "Payment Failed"
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-black mb-4",
          children: ["We're sorry, but we were unable to process your payment.", /*#__PURE__*/_jsx("br", {}), "If the amount has been debited from your account, it will be refunded within 3 working days."]
        }), /*#__PURE__*/_jsxs("p", {
          className: "text-black",
          children: ["You can also track your orders on the", " ", /*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              var _history$push4;
              return history === null || history === void 0 || (_history$push4 = history.push) === null || _history$push4 === void 0 ? void 0 : _history$push4.call(history, ordersRoute);
            },
            className: "text-blue-800 cursor-pointer",
            children: "My Orders"
          }), " ", "page."]
        }), /*#__PURE__*/_jsx("button", {
          className: " mt-4 px-4 py-2 bg-blue-800 text-white rounded",
          children: /*#__PURE__*/_jsxs("div", {
            className: "flex items-center gap-1",
            children: [/*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14.216",
              height: "14.216",
              viewBox: "0 0 14.216 14.216",
              children: /*#__PURE__*/_jsxs("g", {
                id: "reload",
                transform: "translate(-2 -2)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_7395",
                  "data-name": "Path 7395",
                  d: "M15.569,3.422a.711.711,0,0,0-.711.711v.713A7.108,7.108,0,0,0,2.24,7.529a.711.711,0,0,0,1.387.315,5.68,5.68,0,0,1,10.46-1.579H12.726a.711.711,0,1,0,0,1.422h2.843a.711.711,0,0,0,.711-.711V4.132A.711.711,0,0,0,15.569,3.422Z",
                  transform: "translate(-0.064)",
                  fill: "#fff"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_7396",
                  "data-name": "Path 7396",
                  d: "M2.711,17.975a.711.711,0,0,0,.711-.711v-.729A7.1,7.1,0,0,0,16.04,13.868a.711.711,0,0,0-1.387-.315A5.677,5.677,0,0,1,4.2,15.132H5.554a.711.711,0,1,0,0-1.422H2.711A.711.711,0,0,0,2,14.421v2.843a.711.711,0,0,0,.711.711Z",
                  transform: "translate(0 -3.181)",
                  fill: "#fff"
                })]
              })
            }), /*#__PURE__*/_jsx("p", {
              children: "Try Again"
            })]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "mt-12 bg-[#EDEEF0] rounded-xl p-6 flex flex-col md:flex-row md:items-center md:justify-between mr-3 md:mr-0",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "text-left mb-6 lg:mb-0",
            children: [/*#__PURE__*/_jsx("h3", {
              className: "text-lg font-bold",
              children: "Need Assistance ?"
            }), /*#__PURE__*/_jsx("p", {
              className: "text-black",
              children: "Try contacting us"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex items-center justify-center md:justify-end gap-4 text-left cursor-pointer md:-mt-4 lg:-mt-0 xl:-mt-0",
            onClick: function onClick() {
              var _window, _history$push5;
              (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("ContactUsClicked", {
                Section: "Order Status"
              });
              history === null || history === void 0 || (_history$push5 = history.push) === null || _history$push5 === void 0 || _history$push5.call(history, "/contact-us");
            },
            children: [/*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "37.323",
              height: "30.833",
              viewBox: "0 0 37.323 30.833",
              children: /*#__PURE__*/_jsx("path", {
                id: "customer-service",
                d: "M45.307,67.956a5.376,5.376,0,0,1-5.134,5.6q-.125.006-.249.006a5.272,5.272,0,0,1-1.124-.122,14.479,14.479,0,0,1-9.787,6.413,3.13,3.13,0,1,1-.1-2.273,12.194,12.194,0,1,0-12.9-6.045.74.74,0,0,1,.075.19,1.126,1.126,0,0,1-.626,1.42,5.316,5.316,0,0,1-2.063.416q-.125,0-.251-.006a5.375,5.375,0,0,1-5.131-5.6c.024-.567.011-1.073,0-1.562-.012-.461-.025-.937,0-1.434a5.38,5.38,0,0,1,5.4-5.139,14.449,14.449,0,0,1,26.5,0,5.376,5.376,0,0,1,5.4,5.138c.021.5.008.974,0,1.435C45.3,66.883,45.283,67.389,45.307,67.956ZM36.129,65.59a9.47,9.47,0,0,1-11.9,9.15L20.4,76.953a1.129,1.129,0,0,1-1.655-1.27l.979-3.653a9.467,9.467,0,1,1,16.406-6.44Zm-12.1,0A1.129,1.129,0,0,0,22.9,64.461h0a1.129,1.129,0,1,0,1.131,1.129Zm3.761,0a1.068,1.068,0,0,0-.006-.111,1.053,1.053,0,0,0-.016-.11.854.854,0,0,0-.027-.107c-.01-.035-.023-.07-.037-.1a.926.926,0,0,0-.047-.1,1.087,1.087,0,0,0-.056-.095,1.1,1.1,0,0,0-.066-.09.952.952,0,0,0-.074-.082c-.026-.026-.053-.051-.082-.075s-.059-.045-.09-.065a1.083,1.083,0,0,0-.095-.056c-.032-.017-.066-.033-.1-.047a1,1,0,0,0-.1-.037.989.989,0,0,0-.217-.044,1.157,1.157,0,0,0-.331.016,1.07,1.07,0,0,0-.108.028.991.991,0,0,0-.1.037c-.034.014-.068.03-.1.047s-.064.036-.095.056a1.1,1.1,0,0,0-.089.065c-.029.024-.056.049-.083.075a.963.963,0,0,0-.075.082,1.09,1.09,0,0,0-.065.09,1.074,1.074,0,0,0-.057.095,1.01,1.01,0,0,0-.047.1,1.106,1.106,0,0,0-.038.1c-.01.035-.019.071-.027.107a1.075,1.075,0,0,0-.017.11c0,.037-.005.074-.005.111s0,.074.005.111a1.092,1.092,0,0,0,.017.109c.008.036.017.072.027.108a1.093,1.093,0,0,0,.038.1,1.023,1.023,0,0,0,.047.1c.017.032.037.064.057.095a1.079,1.079,0,0,0,.065.089,1.107,1.107,0,0,0,.075.083c.026.026.053.051.083.075a.965.965,0,0,0,.089.065c.031.02.062.04.095.057a1.247,1.247,0,0,0,.2.084c.035.011.071.02.108.027a1.076,1.076,0,0,0,.22.022,1.135,1.135,0,0,0,.8-.33,1.221,1.221,0,0,0,.141-.172q.03-.046.056-.095c.017-.032.033-.066.047-.1a1.047,1.047,0,0,0,.037-.1.9.9,0,0,0,.027-.108,1.069,1.069,0,0,0,.016-.109,1.082,1.082,0,0,0,.006-.112Zm3.762,0a1.129,1.129,0,0,0-1.129-1.129h0a1.129,1.129,0,1,0,1.131,1.129Z",
                transform: "translate(-8.001 -51.138)",
                fill: "#4652a4"
              })
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h4", {
                className: "text-lg font-bold",
                children: "Contact Us"
              }), /*#__PURE__*/_jsx("p", {
                className: "text-black",
                children: "Tell us more about your query"
              })]
            }), /*#__PURE__*/_jsx("svg", {
              className: "ml-2 lg:ml-6",
              xmlns: "\r\nhttp://www.w3.org/2000/svg",
              width: "9.709",
              height: "17.068",
              viewBox: "0 0 9.709 17.068",
              children: /*#__PURE__*/_jsx("g", {
                id: "next",
                transform: "translate(0.568 0.568)",
                children: /*#__PURE__*/_jsx("g", {
                  id: "Group_11658",
                  "data-name": "Group 11658",
                  children: /*#__PURE__*/_jsx("path", {
                    id: "Path_7346",
                    "data-name": "Path 7346",
                    d: "M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z",
                    transform: "translate(-117.742 0)",
                    fill: "#16519e",
                    stroke: "#16519e",
                    "stroke-width": "1"
                  })
                })
              })
            })]
          })]
        })]
      })
    }), /*  */isPoints ? (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) > 0 && (deals === null || deals === void 0 ? void 0 : deals.length) > 0 : (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission) + (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.rewardPoints) > 0 && (deals === null || deals === void 0 ? void 0 : deals.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: "py-5 px-10",
      children: [/*#__PURE__*/_jsx("p", {
        className: "mb-4 text-xl text-primary font-semibold",
        children: "You have more rewards to redeem"
      }), (deals === null || deals === void 0 ? void 0 : deals.length) > 0 && /*#__PURE__*/_jsx(DealSection, {
        type: " ",
        offers: deals.slice(0, 4),
        isRewards: true,
        isPoints: isPoints
      }), /*#__PURE__*/_jsx("button", {
        onClick: function onClick() {
          var _history$push6;
          return history === null || history === void 0 || (_history$push6 = history.push) === null || _history$push6 === void 0 ? void 0 : _history$push6.call(history, isPoints ? "/rewardpointstore" : "/rewardStore");
        },
        className: "flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-6 mt-8",
        children: "View More Rewards"
      })]
    })]
  });
};
export default Confirmation;